const state = {
    operationMap: {},

    cubeValues: [],
    userName: '',
    dateStr: ''
};
const getters = {
    cubeDetails: state => {
        return {
            userName: state.userName,
            dateStr: state.dateStr,
            values: state.cubeValues
        }
    }
};
const actions = {
    clearSelect(context) {
        context.commit('setCubeValues', []);
        context.commit('setUserName', '');
        context.commit('setDateStr', '');
    }
};
const mutations = {
    setOperationMap(state, val) {
        state.operationMap = val;
    },
    setCubeValues(state, val) {
        state.cubeValues = val;
    },
    setUserName(state, val) {
        state.userName = val;
    },
    setDateStr(state, val) {
        state.dateStr = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}